<template>
  <div class="my-10 flex items-start justify-center gap-10 md:mx-10">
    <RegisterFormContainer :title="title" :desc="desc" class="flex-1">
      <!-- isIbtStepper is true For IBT, false for General -->
      <div
        v-if="isShowLetftStepper"
        class="ml-10 my-10 overflow-hidden flex flex-col items-stretch justify-start gap-3.5 md:flex-row md:gap-0"
      >
        <div
          class="overflow-auto flex-none flex flex-col items-center justify-start gap-10"
          :class="isIbtStepper ? 'pr-10 md:flex-[200]' : 'pr-right-10'"
        >
          <RegisterProgress
            v-if="type !== 'BankWireTransfer'"
            class="hidden md:block"
            :percentage="percentage"
            :isIbtStepper="isIbtStepper"
          />
          <RegisterStepper v-if="isIbtStepper" :step="activeTab" :steps="tabs" />
          <RegisterStepperGeneral v-else :step="activeTab" :steps="tabs" />
        </div>
        <div
          :class="isIbtStepper ? 'mr-10' : ''"
          class="flex-none border-r border-r-dashed border-r-blackG4 opacity-40"
        />
        <template v-if="loadedTabs.length > 0">
          <component
            v-for="tab in loadedTabs"
            v-show="tab.step === activeTab"
            :key="tab.step"
            :is="tab.component"
            class="!flex-[620]"
          />
        </template>
        <slot v-else class="!flex-[620]" />
      </div>
      <!-- For General -->
      <div v-else class="flex flex-col items-stretch justify-start overflow-hidden">
        <template v-if="loadedTabs.length > 0">
          <component v-for="tab in loadedTabs" v-show="tab.step === activeTab" :key="tab.step" :is="tab.component" />
        </template>
        <slot v-else />
      </div>
    </RegisterFormContainer>
  </div>
</template>

<script>
import RegisterFormContainer from '../registerForms/RegisterFormContainer.vue';
import RegisterProgress from './RegisterProgress.vue';
import RegisterStepper from './RegisterStepper.vue';
import RegisterStepperGeneral from './RegisterStepperGeneral.vue';

// 固定进度百分比
const STEP_PERCENTAGES = [0, 33, 67, 100];

export default {
  name: 'RegisterTemplate',
  components: { RegisterFormContainer, RegisterStepper, RegisterProgress, RegisterStepperGeneral },
  props: {
    title: { type: String, required: true },
    desc: { type: String, default: '' },
    activeTab: { type: Number, required: true },
    // Array<RegisterFormTab>
    tabs: { type: Array, default: [] },
    isIbtStepper: { type: Boolean, default: false },
    type: { type: String, default: '' }
  },
  data() {
    return { percentage: 0, loadedTabs: [] };
  },
  watch: {
    activeTab() {
      this.loadTab();
    }
  },
  computed: {
    stepPercentages() {
      // step 1 of OpenAccount is only static for showing progress bar
      return this.type === 'OpenAccount' ? STEP_PERCENTAGES : STEP_PERCENTAGES.slice(1);
    },
    isShowLetftStepper() {
      // For BankWireTransfer of IBT, not show left progress bar
      return this.isIbtStepper ? true : this.type === 'BankWireTransfer' ? false : true;
    }
  },
  mounted() {
    // loadTab if it does not already exist in the loadedTabs array.

    // const tabIndex = this.tabs.findIndex(e => e.step === this.activeTab);
    // if (tabIndex !== 3) {
    //   this.loadTab();
    // }

    // openAccount need to show the forth step, so when tabindex === 3 also loadTab();
    this.loadTab();
  },
  methods: {
    loadTab() {
      const isExist = this.loadedTabs.find(e => e.step === this.activeTab) ? true : false;
      if (!isExist) {
        const tabIndex = this.tabs.findIndex(e => e.step === this.activeTab);
        if (tabIndex >= 0) {
          this.percentage = this.isIbtStepper
            ? ((tabIndex + 1) / this.tabs.length) * 100
            : this.stepPercentages[tabIndex];

          const tab = this.tabs[tabIndex];
          this.loadedTabs.push(tab);
          this.loadedTabs.sort((a, b) => a.step - b.step);
        }
      } else {
        const tabIndex = this.tabs.findIndex(e => e.step === this.activeTab);
        if (tabIndex >= 0) {
          this.percentage = this.isIbtStepper
            ? ((tabIndex + 1) / this.tabs.length) * 100
            : this.stepPercentages[tabIndex];
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pr-right-10 {
  padding-right: 10px;
}
@import '@/assets/css/components/register/_registerTemplateTabs.scss';
</style>
